export function isUserPremium(user) {
  if (!user?.premiumEndDate) return false;

  const premiumEnd = new Date(user.premiumEndDate);
  const now = new Date();

  return premiumEnd >= now;
}

export function isUserAdmin(user) {
  return user.address === "0xdf26376de6cba19e";
}
